/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCbpPort.ts                       *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/cbp-port";

export class AutogenModelCbpPort<RowType extends ModelRow> extends Endpoint<RowType, RowCbpPortFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCbpPort extends ModelRow<RowCbpPortFields> {
	constructor(values?: Partial<RowCbpPortFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCbpPortFields {
	ace_enabled: string;
	company_id: string;
	district_code: string;
	port_code: string;
	port_name: string;
}

